<template>
  <div>
    <div class="panel-heading">
      <h4 class="panel-title">Staff</h4>
    </div>

    <div
      class="panel-body"
      style="display: block;"
    >
      <div class="row">
        <preDatatableComponent
          :permissions="{
            add_staff: 'add_staff'
          }"
          :removeAddButton="true"
          :removeWarehouseDeliverButton="true"
          :addInsertStaffButton="true"
          :openAddStaffModal="openAddStaffModal"
          :tableData="tableData"
          :resetGetResults="resetGetResults"
          :resetGetResults2="resetGetResults2"
          :searchMe="searchMe"
          :pagination="pagination"
          :perPageFix="perPageFix"
          :filterTable="filterTable"
          :columns="columns"
          :showHideColumn="showHideColumn"
          :filterMade="filterMade"
          :totalResult="totalResult"
        ></preDatatableComponent>
        <div class="col-xs-12">
          <div class="row text-center">
            <span
              id="test-editable"
              style="opacity:0"
            ></span>
          </div>
          <datatable
            v-if="!isMobile"
            :sortDir="tableData.sortDir"
            :columns="columns"
            :sortByColumn="sortByColumn"
            :searchOneCol="searchOneCol"
            :sortKey="sortKey"
            :sortOrders="sortOrders"
          >
            <tbody>
              <tr
                v-for="r in apiResults"
                :key="r.user_id"
              >
                <td>{{ r.user_id }}</td>
                <td>{{ r.full_name }}</td>
                <!-- <td>{{ r.branch_name }}</td> -->
                <td>{{ r.email }}</td>
                <td>{{ r.phone_number }}</td>

                <td v-if="r.is_blocked === '0'">
                  <span class="label bg-green-600">Unblock</span>
                </td>
                <td v-else>
                  <span class="label bg-warning">Block</span>
                </td>

                <td>
                  <span
                    v-for="(userRole, index) in r.user_roles"
                    :key="index"
                    class="label bg-grey mr-2"
                  >
                    {{ userRole.role.status }}
                  </span>
                </td>

                <td>
                  <span
                    v-for="(w, index) in r.warehouse_id_fk"
                    :key="index"
                  >
                    <span
                      v-if="index % 2 == 0"
                      style="display: inline;"
                    >
                      <span v-if="w == 1">
                        <flag iso="um" /> USA, &nbsp;
                      </span>
                      <span v-else-if="w == 2">
                        <flag iso="tr" /> Turkey, &nbsp;
                      </span>
                      <span v-else-if="w == 3">
                        <flag iso="cn" /> China, &nbsp;
                      </span>
                      <span v-else-if="w == 4">
                        <flag iso="de" /> German, &nbsp;
                      </span>
                      <span v-else-if="w == 5">
                        <flag iso="gb" /> UK, &nbsp;
                      </span>
                      <span v-if="index == 2 || index == 6"><br /></span>
                    </span>
                  </span>
                </td>

                <td
                  v-if="$_has_perm('edit_staff')"
                  style="padding-left:0px; padding-right:5px"
                >
                  <a
                    style="color:#01579B"
                    tooltip="Edit Staff"
                    @click="openEditStaffModal(r)"
                  >
                    <i class="material-icons">edit</i>
                  </a>
                </td>
                <td
                  v-if="$_has_perm('reset_password')"
                  style="padding-left:0px; padding-right:5px"
                >
                  <a
                    style="color:#494949"
                    tooltip="Reset Password"
                    @click="openResetPasswordModal(r.user_id)"
                  >
                    <i class="material-icons">vpn_key</i>
                  </a>
                </td>
                <td
                  v-if="r.is_blocked === '0' && $_has_perm('block_unblock_staff')"
                  style="padding-left:0px; padding-right:5px"
                >
                  <a
                    style="color:#FF5722"
                    tooltip="Block This User"
                    @click="blockUser(r.user_id)"
                  >
                    <i class="material-icons">lock_outline</i>
                  </a>
                </td>
                <td
                  v-else-if="$_has_perm('block_unblock_staff')"
                  style="padding-left:0px; padding-right:5px"
                >
                  <a
                    style="color:#7CB342"
                    tooltip="Unblock This User"
                    @click="unblockUser(r.user_id)"
                  >
                    <i class="material-icons">lock_open</i>
                  </a>
                </td>
              </tr>
              <tr id="no-result-row">
                <td
                  :colspan="columns.length"
                  class="text-center"
                >
                  <v-alert
                    phone_number="error"
                    :value="alertValue"
                  >
                    No Results Found
                  </v-alert>
                </td>
              </tr>
            </tbody>
          </datatable>

          <mobile-datatable
            v-if="isMobile"
            :isStaff="true"
          >
            <tbody>
              <tr
                v-for="r in apiResults"
                :key="r.order_id"
              >
                <td>
                  ID: {{ r.user_id }} , <br />
                  Name: {{ r.full_name }} , <br />
                  {{ r.email }} , <br />
                  {{ r.phone_number }}
                </td>
                <td>
                  <span v-if="r.is_blocked === '0'">
                    <span class="label bg-green-600">Unblock</span>
                  </span>
                  <span v-else>
                    <span class="label bg-warning">Block</span>
                  </span>

                  <span v-if="r.status === 'admin'">
                    <br />
                    <span
                      class="label bg-teal-600"
                      style="margin-top: 3px"
                    > {{ r.status }}</span>
                  </span>
                  <span v-else-if="r.status === 'order'">
                    <br />
                    <span
                      class="label bg-purple-400"
                      style="margin-top: 3px"
                    > {{ r.status }}</span>
                  </span>
                  <span v-else>
                    <br />
                    <span
                      class="label bg-slate-400"
                      style="margin-top: 3px"
                    > {{ r.status }}</span>
                  </span>
                  <br />
                  <span
                    v-for="(w, index) in r.warehouse_id_fk"
                    :key="index"
                  >
                    <span
                      v-if="index % 2 == 0"
                      style="display: inline;"
                    >
                      <span v-if="w == 1">
                        <flag iso="um" /> USA, &nbsp;
                      </span>
                      <span v-else-if="w == 2">
                        <flag iso="tr" /> Turkey, &nbsp;
                      </span>
                      <span v-else-if="w == 3">
                        <flag iso="cn" /> China, &nbsp;
                      </span>
                      <span v-else-if="w == 4">
                        <flag iso="de" /> German, &nbsp;
                      </span>
                      <span v-else-if="w == 5">
                        <flag iso="gb" /> UK, &nbsp;
                      </span>
                      <span v-if="index == 2 || index == 6"><br /></span>
                    </span>
                  </span>

                  <br />
                  <span
                    v-if="$_has_perm('edit_staff')"
                    style="padding-left:0px; padding-right:0px; display: inline-block"
                  >
                    <a
                      :class="loggedInUserData.user_id == r.user_id ? 'disabled' : ''"
                      style="color:#01579B; padding-left: 5px"
                      tooltip="Edit Staff"
                      @click="openEditStaffModal(r)"
                    >
                      <i class="material-icons">edit</i>
                    </a>
                  </span>
                  <span
                    v-if="$_has_perm('reset_password')"
                    style="padding-left:0px; padding-right:0px; float: left"
                  >
                    <a
                      :class="loggedInUserData.user_id == r.user_id ? 'disabled' : ''"
                      style="color:#494949"
                      tooltip="Reset Password"
                      @click="openResetPasswordModal(r.user_id)"
                    >
                      <i class="material-icons">vpn_key</i>
                    </a>
                  </span>
                  <span
                    v-if="r.is_blocked === '0' && r.status !== 'admin' && $_has_perm('block_unblock_staff')"
                    style="float: left; padding-left:0px; padding-right:0px"
                  >
                    <a
                      style="color:#FF5722; padding-left: 5px"
                      tooltip="Block This User"
                      @click="blockUser(r.user_id)"
                    >
                      <i class="material-icons">lock_outline</i>
                    </a>
                  </span>
                  <span
                    v-else-if="r.status !== 'admin' && $_has_perm('block_unblock_staff')"
                    style="float: left; padding-left:0px; padding-right:0px"
                  >
                    <a
                      style="color:#7CB342"
                      tooltip="Unblock This User"
                      @click="unblockUser(r.user_id)"
                    >
                      <i class="material-icons">lock_open</i>
                    </a>
                  </span>
                </td>
              </tr>
              <tr id="no-result-row">
                <td
                  colspan="2"
                  class="text-center"
                >
                  <v-alert
                    type="error"
                    :value="alertValue"
                  >
                    No Results Found
                  </v-alert>
                </td>
              </tr>
            </tbody>
          </mobile-datatable>

          <add-staff
            :addStaffModal="addStaffModal"
            :addStaff="addStaff"
            :roles="roles"
            :warehouses="warehouses"
            :branches="branches"
            :addData="addData"
            :checkAlert="checkAlert"
            :validationError="validationError"
            :emailError="emailError"
            :phoneValidation="phoneValidation"
            :phoneError="phoneError"
            :closeAddStaffModal="closeAddStaffModal"
          ></add-staff>

          <edit-staff
            :editStaffModal="editStaffModal"
            :editStaff="editStaff"
            :roles="roles"
            :warehouses="warehouses"
            :branches="branches"
            :editStaffData="editStaffData"
            :checkAlert="checkAlert"
            :validationError="validationError"
            :backendError="backendError"
            :emailError="emailError"
            :closeEditStaffModal="closeEditStaffModal"
          ></edit-staff>

          <reset-password
            :resetPasswordModal="resetPasswordModal"
            :resetPassword="resetPassword"
            :resetPasswordData="resetPasswordData"
            :checkAlert="checkAlert"
            :closeResetPasswordModal="closeResetPasswordModal"
          ></reset-password>

          <hr />
          <div class="row">
            <div class="col-xs-12 text-right">
              <paginate
                :page-count="pagination.lastPage"
                :page-range="2"
                :changePage="changePage"
                :container-class="'pagination'"
                :pagination="pagination"
                :page-class="'page-item'"
              ></paginate>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PaginationVue from '../Pagination'
import preDatatableComponent from '../preDatatableComponent'
import DatatableVue from '../Datatable'
import addStaff from './addStaff.vue'
import editStaff from './editStaff.vue'
import resetPassword from './resetPassword.vue'
import mobileDatatable from '../mobileDatatable'
import axios from 'axios'
import swal from 'sweetalert'

export default {
  components: {
    preDatatableComponent: preDatatableComponent,
    datatable: DatatableVue,
    paginate: PaginationVue,
    'add-staff': addStaff,
    'edit-staff': editStaff,
    'reset-password': resetPassword,
    'mobile-datatable': mobileDatatable
  },
  created() {
    if (this.queryParameter === true) {
      if (
        window.location.search.replace('?name=', '') !== null ||
        window.location.search.replace('?name=', '') !== ''
      ) {
        let value = window.location.search.replace('?name=', '')
        this.searchOneCol('full_name', value)
      }
    }
    this.getResults()
    this.getLoggedInUser()
  },
  mounted() {
    this.getWarehouses()
    this.getBranches()
    this.getRoles()
    this.perPageFix()

    if (screen.width <= 600) {
      this.isMobile = true
    } else {
      this.isMobile = false
    }
  },
  $_veeValidate: {
    validator: 'new'
  },
  data() {
    let sortOrders = {}
    let columns = [
      { label: 'ID', text: 'ID', value: '1', sortable: true, searchable: true, name: 'user_id' },
      {
        label: 'Name',
        text: 'Name',
        value: '2',
        sortable: true,
        searchable: true,
        name: 'full_name'
      },
      // {
      //   label: 'Default Branch',
      //   text: 'Default Branch',
      //   value: '3',
      //   sortable: true,
      //   searchable: true,
      //   name: 'branch_name'
      // },
      {
        label: 'Email',
        text: 'Email',
        value: '3',
        sortable: true,
        searchable: true,
        name: 'email'
      },
      {
        label: 'Phone Number',
        text: 'Phone Number',
        value: '4',
        sortable: true,
        searchable: true,
        name: 'phone_number'
      },
      {
        label: 'Status',
        text: 'Status',
        value: '5',
        sortable: true,
        searchable: true,
        name: 'is_blocked'
      },
      { label: 'Role', text: 'Role', value: '6', sortable: false, searchable: false, name: 'user_roles' },
      {
        label: 'Warehouse',
        text: 'Warehouse',
        value: '7',
        sortable: true,
        searchable: true,
        name: 'country'
      }
    ]
    columns.forEach(column => {
      sortOrders[column.name] = -1
    })

    return {
      isMobile: false,
      loading: false,
      url: 'api/users',
      addStaffModal: false,
      resetPasswordModal: false,
      blockUserUrl: 'api/users',
      unBlockUserUrl: 'api/users',
      resetPasswordUrl: 'api/users',
      editStaffUrl: 'api/update-staff',
      rowIndex: '',
      alertValue: false,
      filterMade: false,
      totalResult: 0,
      checkAlert: false,
      validationError: false,
      phoneValidation: false,
      editStaffModal: false,
      backendError: false,
      queryParameter: true,
      emailError: '',
      phoneError: '',
      btnsave: true,
      prevSearchQuery: '',
      apiResults: [],
      loggedInUserData: {},
      roles: [],
      warehouses: [],
      branches: [],
      columns: columns,
      sortKey: 'user_id',
      sortOrders: sortOrders,
      resetPasswordData: {
        new_password: '',
        confirm_password: ''
      },
      addData: {
        rolesId: [],
        warehouse_id_fk: []
      },
      editStaffData: {
        rolesId: [],
        warehouse_id_fk: [1]
      },
      tableData: {
        per_page: 10,
        search: '',
        column: 'user_id',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    }
  },

  methods: {
    getRoles() {
      this.roles = []
      let token = localStorage.getItem('access_token')
      axios
        .get('api/role/list', { headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          response.data.forEach(r => {
            this.roles.push({ text: r.status, value: r.role_id })
          })
        })
    },

    getWarehouses() {
      this.warehouses = []
      let token = localStorage.getItem('access_token')
      axios
        .get('api/warehouses', { headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          let result = response.data.data
          result.forEach(r => {
            this.warehouses.push({ text: r.country, value: r.warehouse_id })
          })
        })
    },

    getBranches() {
      this.branches = []
      let token = localStorage.getItem('access_token')
      axios
        .get('api/branch/list', { headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          let result = response.data
          result.forEach(r => {
            this.branches.push({ text: r.branch_name, value: r.branch_id })
          })
        })
    },

    showHideColumn(prevColVal, currentColVal) {
      let a = []
      let diff = []

      if (currentColVal.length < prevColVal.length) {
        for (let i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true
        }

        for (let i = 0; i < currentColVal.length; i++) {
          if (a[currentColVal[i]]) {
            delete a[currentColVal[i]]
          } else {
            a[currentColVal[i]] = true
          }
        }

        for (let k in a) {
          diff.push(k)
        }

        for (let c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle()
        }
      } else {
        for (let i = 0; i < currentColVal.length; i++) {
          let visible = $(
            'td:nth-child(' + currentColVal[i] + '),th:nth-child(' + currentColVal[i] + ')'
          ).is(':visible')
          if (visible) {
            $(
              'td:nth-child(' + currentColVal[i] + '),th:nth-child(' + currentColVal[i] + ')'
            ).toggle()
          }
        }
      }
    },

    getLoggedInUser() {
      this.loggedInUserData = JSON.parse(localStorage.getItem('user_data'))
    },

    getResults(url = this.url) {
      let token = localStorage.getItem('access_token')
      let theDatatable = document.querySelector('.the-datatable')
      let thePanel = document.querySelector('.panel-flat')

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out')
        thePanel.style.overflowX = 'auto'
      }

      axios
        .get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          let data = response.data
          if (data.data.length > 0) {
            this.filterMade = true
            this.apiResults = data.data
          } else {
            this.filterMade = false
            this.apiResults = data.data.data
          }

          if (this.apiResults.length === 0) {
            this.tableData.searchOneCol = ''
            this.tableData.searchOneVal = ''
            this.tableData.search = ''
            this.alertValue = true
          } else {
            this.alertValue = false
          }
          if (data.data.length > 0) {
            this.removeConfigPagination()
          } else {
            this.configPagination(data.data)
          }
          theDatatable.classList.remove('slide-table-out')
          setTimeout(function () {
            thePanel.style.overflowX = 'auto'
          }, 0)
        })
        .then(() => {
          this.totalResult = 0
          for (let i = 0; i < this.apiResults.length; i++) {
            this.totalResult += 1
          }
        })
    },

    removeConfigPagination() {
      this.pagination.lastPage = ''
      this.pagination.currentPage = ''
      this.pagination.total = ''
      this.pagination.lastPageUrl = ''
      this.pagination.nextPageUrl = ''
      this.pagination.prevPageUrl = ''
      this.pagination.from = ''
      this.pagination.to = ''
    },

    resetGetResults() {
      this.queryParameter = false
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'user_id'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'user_id'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.filterTable(this.tableData.from_date, this.tableData.to_date)
      this.sortByColumn()
      this.getResults()
    },

    resetGetResults2() {
      this.queryParameter = false
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'user_id'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'user_id'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.getResults()
    },

    blockUser(id) {
      let token = localStorage.getItem('access_token')
      axios
        .delete(this.blockUserUrl + '/' + id, { headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          swal({
            title: 'Done',
            text: '',
            icon: 'success',
            timer: 1500,
            buttons: false
          })
          this.getResults()
        })
        .catch(error => {
          swal('Error', `${error.response.data.message}`, 'error')
        })
    },

    unblockUser(id) {
      let token = localStorage.getItem('access_token')
      axios
        .put(this.unBlockUserUrl + '/' + id + '/unblock', '', {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then(response => {
          swal({
            title: 'Done',
            text: '',
            icon: 'success',
            timer: 1500,
            buttons: false
          })
          this.getResults()
        })
        .catch(error => {
          swal('Error', `${error.response.data.message}`, 'error')
        })
    },

    openResetPasswordModal(userId) {
      this.the_user_id = userId
      this.resetPasswordModal = true
    },

    closeResetPasswordModal() {
      this.resetPasswordModal = false
      this.checkAlert = false
      this.clearResetPassword()
    },

    clearResetPassword() {
      this.resetPasswordData.new_password = ''
      this.resetPasswordData.confirm_password = ''
      this.$validator.reset()
    },

    resetPassword() {
      let token = localStorage.getItem('access_token')
      let user = JSON.parse(localStorage.getItem('user_data'))

      if (this.the_user_id === user.user_id) {
        swal(
          'Not Allowed',
          "You can't reset your password here, You can only reset password for others",
          'error'
        )
      } else {
        axios
          .put(
            this.resetPasswordUrl + '/' + this.the_user_id + '/reset_password',
            this.resetPasswordData,
            { headers: { Authorization: 'Bearer ' + token } }
          )
          .then(response => {
            this.checkAlert = true
            this.getResults()
          })
          .catch(error => {
            swal('Error', `${error.response.data.message}`, 'error')
          })
      }
    },

    openAddStaffModal() {
      this.addStaffModal = true
    },

    closeAddStaffModal() {
      this.addStaffModal = false
      this.validationError = false
      this.checkAlert = false
      this.clear()
    },

    clear() {
      this.addData = {
        rolesId: [],
        warehouse_id_fk: []
      }
      this.$validator.reset()
    },

    addStaff() {
      let token = localStorage.getItem('access_token')

      axios
        .post(this.url, this.addData, { headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          this.validationError = false
          this.phoneValidation = false
          this.checkAlert = true
          this.getResults()
          this.clear()
        })
        .catch(error => {
          if (error.response.data.message.email) {
            this.checkAlert = false
            this.phoneValidation = false
            this.validationError = true
            this.emailError = error.response.data.message.email[0]
          } else if (error.response.data.message.phone_number) {
            this.checkAlert = false
            this.validationError = false
            this.phoneValidation = true
            this.phoneError = error.response.data.message.phone_number[0]
          }
        })
    },

    openEditStaffModal(r) {
      let w = []
      r.warehouse_id_fk.split(',').forEach(x => {
        w.push(Number(x))
      })
      let rolesId = r.user_roles.map(role => role.role_id_fk)
      // let branchesId = r.user_branches.map(role => role.branch_id_fk)
      let branchesId = []
      this.the_user_id = r.user_id
      this.editStaffData = r
      this.editStaffData.rolesId = rolesId
      this.editStaffData.branchesId = branchesId
      this.editStaffData.warehouse_id_fk = w
      this.editStaffModal = true
    },

    closeEditStaffModal() {
      this.editStaffData = {
        rolesId: [],
        warehouse_id_fk: []
      }
      this.validationError = false
      this.checkAlert = false
      this.editStaffModal = false
    },

    editStaff() {
      let token = localStorage.getItem('access_token')
      axios
        .put(this.editStaffUrl + '/' + this.the_user_id, this.editStaffData, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then(response => {
          this.validationError = false
          this.backendError = false
          this.checkAlert = true
          setTimeout(() => {
            this.checkAlert = false
            this.editStaffModal = false
          }, 2000)
          this.getResults()
        })
        .catch(error => {
          this.checkAlert = false
          if (error.response.data.message) {
            this.validationError = false
            this.backendError = true
            setTimeout(() => {
              this.backendError = false
            }, 2000)
          }
          if (error.response.data.message.email[0]) {
            this.backendError = false
            this.emailError = error.response.data.message.email[0]
            this.validationError = true
            setTimeout(() => {
              this.validationError = false
            }, 2000)
          }
        })
    },

    perPageFix(perPage) {
      this.tableData.per_page = perPage
      this.getResults()
    },

    changePage(pageUrl) {
      this.url = pageUrl
      this.getResults()
    },

    searchMe(str) {
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      if (str.trim() !== '') {
        this.tableData.search = str
        this.prevSearchQuery = str
        this.getResults()
      } else {
        swal({
          text: 'type something to search!',
          icon: 'warning',
          dangerMode: true
        })
        if (this.prevSearchQuery !== '') {
          this.tableData.search = ''
          this.prevSearchQuery = ''
          this.getResults()
        }
      }
    },

    sortByColumn(str) {
      this.tableData.column = str
      this.tableData.sortKey = str
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc'
      this.getResults()
    },

    searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName
      this.tableData.searchOneVal = str
      this.getResults()
    },

    filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate
      this.tableData.to_date = toDate
      this.getResults()
    },

    configPagination(data) {
      this.pagination.lastPage = data.last_page
      this.pagination.currentPage = data.current_page
      this.pagination.total = data.total
      this.pagination.lastPageUrl = data.last_page_url
      this.pagination.nextPageUrl = data.next_page_url
      this.pagination.prevPageUrl = data.prev_page_url
      this.pagination.from = data.from
      this.pagination.to = data.to
    }
  }
}
</script>

<style>
@media screen and (max-width: 600px) {
  th {
    font-weight: bold;
    color: #273246;
    padding-left: 5px !important;
  }

  td {
    padding-left: 5px !important;
    padding-top: 10px !important;
    padding-bottom: 10px !important;
  }
}

.panel-heading {
  color: #006b8d;
  border-bottom: 2px solid #006b8d !important;
}

.panel-heading h4 {
  text-transform: uppercase;
  margin-left: -20px;
  padding-left: 10px;
  font-weight: 500;
}

.btn {
  transition: all 0.5s;
}

.col-xs-12 {
  padding-top: 10px;
  padding-bottom: 10px;
}
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  overflow: hidden;
  overflow-y: hidden;
}
.page-stats {
  align-items: center;
  position: relative;
  top: -8px;
  margin-right: 5px;
}

a.disabled {
  pointer-events: none;
  color: gray;
}

a:hover {
  color: #03a9f4;
  position: relative;
}
a[tooltip]:hover:after {
  content: attr(tooltip);
  padding: 8px 12px;
  color: #ffffff;
  position: absolute;
  right: 80%;
  bottom: 150%;
  white-space: nowrap;
  z-index: 20;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  border-radius: 3px;
  -moz-box-shadow: 0px 0px 2px #484b4e;
  -webkit-box-shadow: 0px 0px 2px #484b4e;
  box-shadow: 0px 0px 2px #484b4e;
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(0, #484b4e),
    color-stop(1, #484b4e)
  );
  background-image: -webkit-linear-gradient(top, #484b4e, #484b4e);
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -ms-linear-gradient(top, #484b4e, #484b4e);
  background-image: -o-linear-gradient(top, #484b4e, #484b4e);
}

@media screen and (max-width: 767px) {
  .form-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/user/user.vue